import {
  TargetCorrectionPaymentInput,
  CreateOrUpdateTargetCorrectionPaymentMutation,
  CreateOrUpdateTargetCorrectionPaymentMutationVariables,
  TargetCorrectionPaymentDto,
} from '../../../types'
import { client } from '../../..'
import { CREATE_OR_UPDATE_TARGET_CORRECTION_PAYMENT, DELETE_TARGET_CORRECTION_PAYMENT } from '../TargetCorrectionMutation'
import { FIND_TARGET_CORRECTION_PAYMENT_BY_MEETING_ID } from '../TargetCorrectionQueries'
import { DataProxy, FetchResult } from '@apollo/client'

export default (): {
  deleteTargetCorrectionPayment: (targetCorrectionPaymentId: number, meetingId: number) => Promise<FetchResult>
  saveTargetCorrectionPayment: (
    targetCorrectionPaymentInput: TargetCorrectionPaymentInput,
    meetingId: number,
  ) => Promise<FetchResult<CreateOrUpdateTargetCorrectionPaymentMutation>>
} => {
  const saveTargetCorrectionPayment = (
    targetCorrectionPaymentInput: TargetCorrectionPaymentInput,
    meetingId: number,
  ): Promise<FetchResult<CreateOrUpdateTargetCorrectionPaymentMutation>> => {
    return client.mutate<CreateOrUpdateTargetCorrectionPaymentMutation, CreateOrUpdateTargetCorrectionPaymentMutationVariables>({
      mutation: CREATE_OR_UPDATE_TARGET_CORRECTION_PAYMENT,
      variables: {
        targetCorrectionPayment: targetCorrectionPaymentInput,
      },
      update: (store: DataProxy, { data }) => {
        if (!data || !data.createOrUpdateTargetCorrectionPayment) {
          return
        }
        // Write our data back to the cache
        store.writeQuery<{ targetCorrectionPaymentByMeetingId: TargetCorrectionPaymentDto }>({
          query: FIND_TARGET_CORRECTION_PAYMENT_BY_MEETING_ID,
          variables: { meetingId: meetingId },
          data: { targetCorrectionPaymentByMeetingId: data.createOrUpdateTargetCorrectionPayment },
        })
      },
    })
  }
  const deleteTargetCorrectionPayment = (targetCorrectionPaymentId: number, meetingId: number): Promise<FetchResult> => {
    return client.mutate({
      mutation: DELETE_TARGET_CORRECTION_PAYMENT,
      variables: {
        targetCorrectionPaymentId: targetCorrectionPaymentId,
      },
      update: (store: DataProxy) => {
        // Write our data back to the cache
        store.writeQuery<{ targetCorrectionPaymentByMeetingId: null }>({
          query: FIND_TARGET_CORRECTION_PAYMENT_BY_MEETING_ID,
          variables: { meetingId: meetingId },
          data: { targetCorrectionPaymentByMeetingId: null },
        })
      },
    })
  }
  return {
    deleteTargetCorrectionPayment,
    saveTargetCorrectionPayment,
  }
}
